$(function(){
	setupDatatables();
})

var datatableDefaultConfig = {
	'fixedHeader': {
		'headerOffset': getNavbarHeight(),
	},
	'language': {
			'paginate': {
					'previous': '<span class="glyphicon glyphicon-chevron-left"></span>',
					'next': '<span class="glyphicon glyphicon-chevron-right"></span>',
			},
			'zeroRecords': localizedTexts.datatables.zeroRecords,
		},
	'pagingType': 'simple_numbers',
	'lengthChange': false,
	'pageLength': 20,
	'info': false,
	'aaSorting': [],
	'searching': false,
	'ordering': true,
};



function setupDatatables() {
	var tableElement = $('table[data-table]');
	
	if (tableElement.length == 0) return;
 
    setupCRMFiltering();
    if(tableElement.is("#crmTable")) {
        setupCrmHomeTable(tableElement);
    } else {
		tableElement.each(function() {
			datatable = setupDatatable($(this));
			datatable.on("draw.dt", function (e, dt, type, indexes) {
				loadFunctionAfterDraw();
			});
			drawDatatable(datatable);
		})
    }
}


function getDatatablesConfig(defaultConfig, tableElement) {
	var attr = tableElement.attr("data-table");
    var dtcfg = {};


    if(typeof attr !== "undefined") {
        try {
            dtcfg = JSON.parse(attr);
        } catch (e) {
            console.error(e);
        }
    }

	const config = mergeConfig(defaultConfig, dtcfg);

	//Step that support to add custom function from $dtSetup config
	$.each(config, function(key, value) {
		if(key.includes("EvalFunction")) 
		{ 
			key = key.replace("EvalFunction", "");
			var functionVar = new Function(value.args, value.function);
			config[key] = functionVar;
		}
	});


    return config;
}

function setupDatatable(tableElement, defaultConfig) {

    if(typeof defaultConfig === "undefined") {
		defaultConfig = datatableDefaultConfig;
	}

	$('.resetSorting').on('click', function() 
	{
		$('.pipelineFilter').removeClass('active');

		$('.datatableFilter').each(function() {
			$(this).find('input:not([type=checkbox])').val('');
			$(this).find('select').val('');
		});	

		datatable.order.neutral().draw();
	});

   
	var config = getDatatablesConfig(defaultConfig, tableElement);

    const datatable = tableElement.DataTable(config);


	setupFilterEvents(datatable);



    return datatable;
}

function mergeConfig(config1, config2) {
    for(var key in config2) {
        config1[key] = config2[key];
    }
    return config1;
}

function setupCrmHomeTable(tableElement) {
	var dtcfg = {};
	var configAttr = tableElement.attr('data-table');

	if(typeof configAttr !== "undefined") {
		try {
			dtcfg = JSON.parse(configAttr);
		} catch (e) {
			console.error(e);
		}
	}

	//var orderBy = dtcfg.orderBy || 0;
	//var orderDirection = dtcfg.orderDirection || "asc";

	var defaultConfig = {
        stateSave: true,
        stateDuration: -1,
        order: [],
        searching: true,
        processing: true,
        pagingType: "full_numbers",
        info: false,
        lengthChange: false,
        pageLength: 50,
        language: {
            zeroRecords: "---",
            processing: "Moment, hned to bude...",
			paginate: {
				previous: '<span class="glyphicon glyphicon-chevron-left"></span>',
				next: '<span class="glyphicon glyphicon-chevron-right"></span>',
				first: '<span class="glyphicon glyphicon-chevron-left font-size-10px"></span><span class="glyphicon glyphicon-chevron-left font-size-10px"></span>',
				last: '<span class="glyphicon glyphicon-chevron-right font-size-10px"></span><span class="glyphicon glyphicon-chevron-right font-size-10px"></span>'
			}
        },
        dom: 'ltipr',
        columnDefs: [ 
        	{
        		"targets": 1,
        		"render": function (data, type, row, meta ) {
				      return '<a href="'+row['link']+'">'+data+'</a>';
				    } 
        	},
        	{
        		"targets": 2,
        		"render": function (data, type, row, meta ) {
				      return '<a data-toggle="tooltip" title="' + data + '" class="truncate-text-400 text-align-left display-block" href="'+row['link']+'">'+data+'</a>';
				    } 
        	},
        	{
	            "targets": ["nextContactDate", "licenceValidUntil", "dateCreated"],
	            "type": "czechDate"
        	},  
        	{
	            "targets": ["playerCount"], 
	            "type": "num"
			},
			{
				"targets": ["crmLabels"],
				"render": function (data, type, row, meta ) {
					var cmrLabels = '';
					Object.keys(data).forEach(function(key) {
						cmrLabels += '<span data-toggle="tooltip" class="label truncate-text-100 w-75 margin-right-5" style="'+ data[key]['style']+'" title="'+ data[key]['text'] +'"><span class="display-none">_</span>'  + data[key]['text'] + '</span>';
					});
					return '<div class="is-flex3 overflow-hidden">' + cmrLabels + '</div>';
				  }
			},
			{
				"targets": ["healthLabels"],
				"render": function (data, type, row, meta ) {
					var healthLabels = '';
					Object.keys(data).forEach(function(key) {
						healthLabels += '<span data-toggle="tooltip" class="label truncate-text-100 w-75 margin-right-5" style="'+ data[key]['style']+'" title="'+ data[key]['tooltip'] +'"><span class="display-none">_</span>'  + data[key]['text'] + '</span>';
					});
					return '<div class="is-flex3 overflow-hidden">' + healthLabels + '</div>';
				  }
			}
		
		],
		
        //serverSide: true,
        ajax: dtcfg.link,
        createdRow: function( row, data, dataIndex ) {
		      $(row).addClass(data.trClass);
		  }
	};

	var datatable = setupDatatable(tableElement, defaultConfig);
	datatable.on("draw.dt", function (e, dt, type, indexes) {
		loadFunctionAfterDraw();
	});

    tableElement.find('.dataTables_filter').hide();

	drawDatatable(datatable);


	const checkboxLists = ['Crm', 'Health'];

	checkboxLists.forEach((value, index) => {

		$(`.cancel${value}Labels`, '.datatableFilter').click(function() {
			$(`.datatableFilter input[name^=${value.toLowerCase()}Labels]`).each(function() {
				$(this).prop( "checked", false );
			});
			drawDatatable(datatable);
		});
	});

	
	$('.resetSorting').click(
		function() 
		{
			const filtersToReset = ['priority-select', 'name-input', 'state-in-crm-select', 'next-contact-reason-select'];
			filtersToReset.forEach((value) => { $(`#${value}`).val(''); });

			const checkboxListsToReset = ['Crm', 'Health'];
			checkboxListsToReset.forEach((value) => {
				$(`.datatableFilter input[name^=${value.toLowerCase()}Labels]`).each(function() {
					$(this).prop( "checked", false );
				});
			});
			

			datatable.order.neutral().draw(); 
			loadFunctionAfterDraw();
		}
	);
}

function setupFilterEvents(datatable) {

	$('#DataTables_Table_0_filter').hide();


	// Event listener to the two range filtering inputs to redraw on input
	$('input', '.datatableFilter').click( function() {
		drawDatatable(datatable);
	} );
	$('input', '.datatableFilter').keyup( function() {
		drawDatatable(datatable);
	} );
	$('input', '.datatableFilter').change( function() {
		drawDatatable(datatable);
	} );

	$('select', '.datatableFilter').change( function() {
		drawDatatable(datatable);
	} );

	$('.filterSubmit', '.datatableFilter').click(function() {
		drawDatatable(datatable);
	});

	$('.reloadTable.datatable').click(function() {
		datatable.ajax.reload(null, false);
		loadFunctionAfterDraw();
	});

}

function drawDatatable(datatable) 
{
	datatable.draw();

	loadFunctionAfterDraw();
}

function loadFunctionAfterDraw() {

	if (jQuery.fn.tooltip !== undefined) {
		$('[data-toggle="tooltip"]').tooltip();
	}

}


function findFilters(datatableId) {

	let filters = [];
	
	const getFilters = (searchSelector) => {


		$(searchSelector).each(
			function (i) 
			{
				if (!$(this).attr('data-filterType')) return; 	
				
				let type = null;	



				if ($(this).find('.checkbox-list .filter-except').length > 0 && $(this).find('.checkbox-list .filter-except').prop('checked')) type = 'checkbox-list-reverse';
				else if ($(this).find('.checkbox-list').length > 0) type = 'checkbox-list';
				else if ($(this).find('input').length > 0) type = 'input';
				else if ($(this).find('select').length > 0) type = 'select';
				else return; 

				const colsSpread = $(this).attr('data-filterType').split('-').length;

				filters[filters.length] = {
					name: $(this).attr('data-filterType'), 
					input: type, 
					index: i,
					colsSpread: colsSpread
				};
			}
		);
	}

	getFilters('#' + datatableId + ' .datatableFilter td');
	getFilters('.' + datatableId + '.datatableFilter .filter');

	return filters;
}

function setupCRMFiltering() {

	/* Custom filtering function which will search data in column four between two values */
	$.fn.dataTable.ext.search.push(
	    function( settings, data, dataIndex ) {


			var filters = findFilters(settings.nTable.id);
	 		for (var i = 0; i < filters.length; ++i) {
				

				if(filters[i].input === 'checkbox-list' || filters[i].input === 'checkbox-list-reverse')
				{
					var value = [];

					$('.datatableFilter input[name^='+filters[i].name+']:checked').each(function() {
						value.push($(this).val().toLowerCase());
					});
				}
				else 
				{
					var value = $('.datatableFilter '+filters[i].input+'[name='+filters[i].name+']').val().toLowerCase();
				}
			

				var date = new Date(value);
				if(date instanceof Date && !isNaN(date)) 
				{
					value = date.toLocaleDateString('cs-CZ', {
						day: '2-digit',
						month: '2-digit',
						year: 'numeric'
					});
				}
				
	 			if (!value) continue;	// filter not set
	 			
	 			if (filters[i].input == 'select') {
	 				if (data[filters[i].index].toLowerCase().trim() !== value) {	// exact match
	 					return false;
	 				}
	 			}
	 			else if(filters[i].input == 'input') {
		 		
					let tableValues = [];
					for(let j = 0; j < filters[i].colsSpread; ++j) {
						tableValues.push(data[filters[i].index + j].toLowerCase().search(value.toLowerCase()) !== -1);
					}

					if(jQuery.inArray(true, tableValues) !== -1) { return true; };

					
					return false;

	 			} 
				 else if (filters[i].input === 'checkbox-list-reverse') {
					rowData = data[filters[i].index].toLowerCase().split('_');
					
					isInArray = 0;
					value.forEach(function(val){
						if(jQuery.inArray(val,rowData) !== -1) {
							isInArray = 1;
						}
					});

					if(isInArray > 0) {
						return false;
					}
				} 
				//For checkbox list
				else 
				{
					rowData = data[filters[i].index].toLowerCase().split('_');
					
					isInArray = 0;
					value.forEach(function(val){
						if(jQuery.inArray(val,rowData) === -1) {
							isInArray++;
						}
					});

					if(isInArray > 0) {
						return false;
					}
				}
				
	 		}

	        return true;
	    }
	);

	$.fn.dataTable.ext.type.order['czechDate-pre'] = 
		function (date) {
			
			if (!date) return '2100-01-01';

			if(date === '---') return date;

			var dateParts = date.split(' ');
			var day = dateParts[0].replace('.', '');
			var month = dateParts[1].replace('.', '');
			var year = dateParts[2];

			if (dateParts[3] != undefined) {
				var timeParts = dateParts[3].split(':');
				var hour = timeParts[0];
				var minute = timeParts[1];
			}
			else {
				var hour = 0;
				var minute = 0;
			}

			var newDate = new Date(year, month-1, day, hour, minute);


			if(newDate instanceof Date && !isNaN(newDate))   
			{
				return newDate.toISOString();
			}

			return date;
		}

	$.fn.dataTable.ext.type.order['currency-pre'] = 
		function (value) 
		{
			if (!value) return 0;
		
			// Remove all non-numeric characters from the string
			return parseFloat(value.replace(/[^0-9.-]+/g, "")) || 0;
		};

	
}